import React, { useMemo, useState } from "react";
import { Table, Tooltip, Modal } from "antd";
import { useSelector } from "react-redux";
import NoGraphData from "../../../workspace/DisplayChart/NoGraphData";
import { CaretUpFilled, CaretDownFilled, CloudFilled } from "@ant-design/icons";
import { isString } from "@microsoft/applicationinsights-core-js";
import { isNumber } from "highcharts";
import isEqual from "react-fast-compare";
import defaultImage from "../../../../assets/brandLogos/Default_Brand.svg";
import { SocialMedialogo } from "../../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import { deepCopy, formatDuration } from "../../../../redux/constants";
import config1 from "../../../../config";
import defaultProfileImg from "../../../../assets/Profile_Pic.svg";
import defaultBrandLogo from "../../../../assets/brandLogos/Default_Brand.svg";
import { SecondstoHumanReadable } from "../../../../components/utils/charts/HighCharts/graphFunction";
import deepLinkIcon from "../../../../assets/deepLink_Icon.svg";
import verified from "../../../../assets/verified.svg";
import DownloadExcel from "../../../layout2/sectionInsight/Widget/WidgetHeader/DownloadExcel";

const { Column } = Table;

const SmartGrid = ({
  tableColumns,
  dataSource,
  colors,
  PdfDownloadStatus,
  metadata,
  noteExist,
  insightsExist,
  tree_grid,
  grand_total,
  widgetDurationComparisonForChart,
  widgetDurationDataForChart,
  rowSpanOn,
  hideColumns,
  hideSorting,
  dateLabels,
  ticketChartData,
  widget_metadata,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);

  const [scrollAbleTable, setScrollAbleTable] = useState(0);
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: scrollAbleTable,
  });
  const [pdfView, setPdfView] = useState(false);
  const [deepLinkModal, setDeepLinkModal] = useState({
    url: null,
    modalShow: false,
  });

  const widgetGraphConfig = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  // Helper function to parse duration strings and convert to comparable numeric values
  const parseDurationToSeconds = (durationStr) => {
    if (!durationStr || typeof durationStr !== "string") return 0;

    let totalSeconds = 0;
    const str = durationStr.toLowerCase().trim();

    // Handle different duration formats
    const dayMatch = str.match(/(\d+)\s*d(ay)?s?/);
    const hourMatch = str.match(/(\d+)\s*h(our)?s?/);
    const minuteMatch = str.match(/(\d+)\s*m(in)?s?/);
    const secondMatch = str.match(/(\d+)\s*s(ec)?s?/);

    if (dayMatch) totalSeconds += parseInt(dayMatch[1]) * 24 * 60 * 60;
    if (hourMatch) totalSeconds += parseInt(hourMatch[1]) * 60 * 60;
    if (minuteMatch) totalSeconds += parseInt(minuteMatch[1]) * 60;
    if (secondMatch) totalSeconds += parseInt(secondMatch[1]);

    return totalSeconds;
  };

  // Enhanced sorting function that handles duration strings
  const createCustomSorter = (column) => {
    return (a, b) => {
      // Skip sorting for total rows
      if ((a?.total_flag || b?.total_flag) && grand_total) return 0;

      let aData = a[column?.dataIndex] || a[column?.title];
      let bData = b[column?.dataIndex] || b[column?.title];

      // Extract values if they're objects
      aData =
        aData?.value !== null && aData?.value !== undefined
          ? aData.value
          : aData;
      bData =
        bData?.value !== null && bData?.value !== undefined
          ? bData.value
          : bData;

      // Handle null/undefined values
      if (aData == null && bData == null) return 0;
      if (aData == null) return 1;
      if (bData == null) return -1;

      // Convert to strings for pattern matching
      const aStr = String(aData);
      const bStr = String(bData);

      // Check if both values contain duration patterns
      const aDurationPattern = /\d+\s*(day|hour|min|sec|d|h|m|s)/i;
      const bDurationPattern = /\d+\s*(day|hour|min|sec|d|h|m|s)/i;

      if (aDurationPattern.test(aStr) && bDurationPattern.test(bStr)) {
        // Both are duration strings, compare by total seconds
        const aSeconds = parseDurationToSeconds(aStr);
        const bSeconds = parseDurationToSeconds(bStr);
        return aSeconds - bSeconds;
      }

      // Check if both are numeric (including string numbers)
      const aNum = parseFloat(aData);
      const bNum = parseFloat(bData);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return aNum - bNum;
      }

      // Handle mixed string/number cases
      if (isString(aData) && isNumber(bData)) return -1;
      if (isNumber(aData) && isString(bData)) return 1;

      // Default string comparison
      return aStr.localeCompare(bStr);
    };
  };
  let datasourceu = [];
  let tableKey = [];
  const getTableColumnsWithSorting = (columns) => {
    columns = columns
      ?.map((column, i) => {
        let isHiddenColumn =
          hideColumns && Array.isArray(hideColumns)
            ? hideColumns?.includes(column?.title || column?.dataIndex)
            : false;
        if (column?.title === "row_span" || isHiddenColumn) return null;
        if (column?.children?.length) {
          setPdfView(true);
          column.children = getTableColumnsWithSorting(column?.children);
        } else {
          column.key = column?.title + "_" + i;
          let isSortHidden =
            hideSorting && Array.isArray(hideSorting)
              ? hideSorting?.includes(column?.title || column?.dataIndex)
              : false;
          if (!rowSpanOn && !isSortHidden) {
            column.sorter = createCustomSorter(column);
          }
        }
        return column;
      })
      ?.filter((el) => el);
    return columns;
  };

  const handleDeepLinkOk = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const handleDeepLinkCancel = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const onExternal = (TicketID, PostBrandID) => {
    // console.log("Inside me", TicketID, PostBrandID);
    setDeepLinkModal({
      url: null,
      modalShow: true,
    });
    let url =
      config1?.config1?.app_id === "10" || config1?.config1?.app_id === 10
        ? "https://preprodcx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "6" || config1?.config1?.app_id === 6
        ? window?.location?.origin?.includes("bbps.locobuzz.com") ||
          window?.location?.ancestorOrigins?.[0]?.includes("bbps.locobuzz.com")
          ? "https://bbps.locobuzz.com/ticketDetail"
          : "https://cx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "4" || config1?.config1?.app_id === 4
        ? window?.location?.origin?.includes("demo.locobuzz.com")
          ? "https://demo.locobuzz.com/ticketDetail"
          : window?.location?.origin?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            ) ||
            window?.location?.ancestorOrigins?.[0]?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            )
          ? "https://locobuzzng-uat-aws.locobuzz.com/ticketDetail"
          : "https://demo.locobuzz.com/ticketDetail"
        : "https://demo.locobuzz.com/ticketDetail";
    // : "https://demo.locobuzz.com/ticketDetail";

    let finalUrl = `${url}/${TicketID}/${PostBrandID}`;
    if (config1?.config1?.app_id === "2") {
      console.log("Deep Link URL =>", finalUrl);
    }

    //window.open(finalUrl);

    setDeepLinkModal({
      url: (
        <iframe
          title="Ticket Details"
          allowfullscreen={true}
          src={finalUrl}
          alt="Ticket Details"
          className="w-100 border-0 border-radius-4"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          style={{ height: "calc(100vh - 6.3rem)", marginTop: "3.7rem" }}
        />
      ),
      modalShow: true,
    });
  };

  if (grand_total && dataSource?.length)
    dataSource[dataSource?.length - 1].total_flag = true;
  dataSource &&
    dataSource.map((el, i) => {
      let rattingType = Object.keys(el);
      tableKey = rattingType;
      if (rattingType?.includes("Review Ratings")) {
        datasourceu.push({
          ...el,
          [`Review Ratings`]: `${el[`Review Ratings`]} ⭐`,
        });
      } else if (rattingType?.includes("Rating")) {
        datasourceu.push({ ...el, [`Rating`]: `${el[`Rating`]} ⭐` });
      }
    });

  let updatedataSource =
    tableKey.includes("Review Ratings") || tableKey.includes("Rating")
      ? datasourceu
      : dataSource;
  const updatedTableColumn = useMemo(
    () => getTableColumnsWithSorting(tableColumns),
    [tableColumns]
  );

  if (PdfDownloadStatus) {
    if (tableKey.includes("Review Ratings") || tableKey.includes("Rating")) {
      if (noteExist && insightsExist && datasourceu?.length > 8)
        updatedataSource = datasourceu?.slice(0, 8);
      else if (datasourceu?.length > 11)
        updatedataSource = pdfView
          ? datasourceu?.slice(0, 9)
          : datasourceu?.slice(0, 11);
    } else {
      if (noteExist && insightsExist && dataSource?.length > 8)
        updatedataSource = dataSource?.slice(0, 8);
      else if (dataSource?.length > 11)
        updatedataSource = pdfView
          ? dataSource?.slice(0, 9)
          : dataSource?.slice(0, 11);
    }
  }
  // enabling peak and valley for smartGrid
  let modifiedArray;
  const showMaxData = true;
  const showMinData = true;
  if (updatedataSource && (showMaxData || showMinData)) {
    const keys = Object.keys(updatedataSource[0]);
    const numericKeys = keys
      .slice(2)
      .filter((key) => typeof updatedataSource[0][key] == "number");

    let maxMinValues = numericKeys.reduce((acc, key) => {
      const shouldExcludeLast =
        (widgetGraphConfig?.chart_settings?.total_row ||
          metadata?.chart?.chart_settings?.total_row) &&
        updatedataSource.length > 1;
      const validValues = updatedataSource
        .map((item) => item[key])
        .filter((value) => value !== "" && value !== "NA");
      const filteredValidValues = shouldExcludeLast
        ? validValues.filter((value, index) => index !== validValues.length - 1)
        : validValues;
      const firstValue = filteredValidValues[0];
      const allSame = filteredValidValues.every(
        (value) => value === firstValue
      );
      if (allSame) {
        acc[key] = firstValue;
      } else {
        acc[key] = {
          max: Math.max(...filteredValidValues),
          min: Math.min(...filteredValidValues),
        };
      }
      return acc;
    }, {});

    let maxUsed = {};
    let minUsed = {};
    numericKeys.forEach((key) => {
      maxUsed[key] = false;
      minUsed[key] = false;
    });

    modifiedArray = updatedataSource.map((item) => {
      let newItem = { ...item };
      numericKeys.forEach((key) => {
        if (newItem[key] == maxMinValues[key].max && !maxUsed[key]) {
          newItem[key] =
            key === "Brand ID" ? newItem[key] : `${newItem[key]}Max`;
          maxUsed[key] = true;
        } else if (newItem[key] == maxMinValues[key].min && !minUsed[key]) {
          newItem[key] =
            key === "Brand ID" ? newItem[key] : `${newItem[key]}Min`;
          minUsed[key] = true;
        }
      });
      return newItem;
    });
  }
  if ((!showMaxData && !showMinData) || metadata?.data_source === "ticket") {
    modifiedArray = updatedataSource;
  }
  let widgetData;
  if (ticketChartData && widget_metadata) {
    widgetData = deepCopy(widget_metadata);
    delete widgetData?.graphData?.data;
    widgetData.graphData.data = { pivot_grid: ticketChartData };
  }

  return updatedTableColumn ? (
    <>
      {" "}
      <div
        id={`table_${metadata?.widget_id}`}
        className="widgetmaker-grid-chart p-15 w-100"
      >
        {tree_grid ? (
          <Table
            dataSource={modifiedArray}
            columns={updatedTableColumn}
            //bordered
            className="custom_table_scroll"
            scroll={
              PdfDownloadStatus || metadata?.span === "one_third"
                ? {}
                : {
                    x: 1000,
                  }
            }
            pagination={
              PdfDownloadStatus
                ? false
                : {
                    hideOnSinglePage: dataSource?.length > 10 ? false : true,
                    defaultPageSize: 10,
                  }
            }
          />
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            {ticketChartData ? (
              <div style={{ height: "5rem", alignSelf: "flex-end" }}>
                <DownloadExcel
                  isDeepDive={true}
                  widgetData={widgetData}
                ></DownloadExcel>
              </div>
            ) : (
              ""
            )}

            <div>
              <Table
                dataSource={modifiedArray}
                className={`custom_table_scroll 
          ${rowSpanOn ? "antd_table-withborder" : ""} 
          ${PdfDownloadStatus ? "" : "overflow_auto"} ${
                  metadata?.span === "one_third" ? "one_third-grid" : ""
                } 
          ${
            scrollAbleTable > 10 || rowSpanOn || PdfDownloadStatus
              ? ""
              : "table-cell-scrllbar-bg-none"
          }
          `}
                //bordered
                scroll={
                  PdfDownloadStatus
                    ? {}
                    : metadata?.span === "one_third" || scrollAbleTable < 11
                    ? { y: "100%", x: "100%" }
                    : scrollAbleTable > 10
                    ? { y: 408, x: "100%" }
                    : { y: "100%", x: "100%" }
                }
                onChange={(pagination, filters, sorter, extra) => {
                  setScrollAbleTable(pagination?.pageSize);
                  setPaginationInfo(pagination);
                }}
                pagination={
                  PdfDownloadStatus
                    ? false
                    : {
                        hideOnSinglePage:
                          updatedataSource?.length > 10 ? false : true,
                        defaultPageSize: 10,
                        showSizeChanger:
                          metadata?.span === "one_third" ? false : true,
                        pageSizeOptions:
                          updatedataSource?.length > 10 &&
                          updatedataSource?.length <= 20
                            ? ["10", "20"]
                            : updatedataSource?.length > 20 &&
                              updatedataSource?.length <= 30
                            ? ["10", "20", "30"]
                            : updatedataSource?.length > 30 &&
                              updatedataSource?.length <= 40
                            ? ["10", "20", "30", "40"]
                            : ["10", "20", "30", "40", "50"],
                        locale: { items_per_page: "" },
                        total: updatedataSource?.length,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total}`,
                      }
                }
              >
                {updatedTableColumn?.map((col, i) => {
                  if (
                    col?.title !== "Brand ID" &&
                    col?.title !== "Sentiment" &&
                    col?.title !== "Agent Pic" &&
                    col?.title !== "FLR Breached" &&
                    col?.title !== "Ticket Sentiment" &&
                    col?.title !== "Mention Sentiment" &&
                    col?.title !== "Upper Category Sentiment"
                  ) {
                    return (
                      <Column
                        width={`${col?.title?.length * 8.5 + 51}px`}
                        title={(value) => {
                          return <span>{col?.title}</span>;
                        }}
                        dataIndex={col?.title}
                        key={i}
                        render={(value, obj, index) => {
                          let maxFlag = value.toLocaleString().includes("Max");
                          let minFlag = value.toLocaleString().includes("Min");
                          if (maxFlag || minFlag) {
                            value = parseFloat(
                              value.slice(0, -3)
                            ).toLocaleString();
                          }
                          const updatedObj = {
                            children: value,
                            props: {},
                          };
                          let channlImage;
                          let channlName;
                          if (
                            (obj?.[`Channel | Inner Channel`] ||
                              obj?.[`Channel Name`]) &&
                            (obj?.[`Channel | Inner Channel`]?.includes(
                              "|$|"
                            ) ||
                              obj?.[`Channel Name`]?.includes("|$|"))
                          ) {
                            channlImage = obj?.[`Channel | Inner Channel`]
                              ? obj?.[`Channel | Inner Channel`]
                                  .split("|$|")?.[0]
                                  ?.trim()
                              : obj?.[`Channel Name`].split("|$|")?.[0]?.trim();

                            channlName = obj?.[`Channel | Inner Channel`]
                              ? obj?.[`Channel | Inner Channel`]
                                  .split("|$|")?.[1]
                                  ?.trim()
                              : obj?.[`Channel Name`].split("|$|")?.[1]?.trim();
                          }
                          updatedObj.children = (
                            <Tooltip
                              title={
                                showMaxData && maxFlag
                                  ? "Max Value"
                                  : showMinData && minFlag
                                  ? "Min Value"
                                  : ""
                              }
                            >
                              <span
                                key={value}
                                style={{
                                  maxWidth: "50rem",
                                  lineHeight: 2,
                                  backgroundColor: `${
                                    i !== 0 && showMaxData && maxFlag
                                      ? "rgba(24, 94, 223, .1)"
                                      : showMinData && minFlag
                                      ? "rgba(160, 32, 240, .1)"
                                      : ""
                                  }`,
                                  color: `${
                                    i !== 0 && showMaxData && maxFlag
                                      ? "#185edf"
                                      : showMinData && minFlag
                                      ? "#a020f0"
                                      : ""
                                  }`,
                                  borderRadius: "0.8rem",
                                  fontWeight: "700",
                                  padding: `${
                                    i !== 0 &&
                                    (maxFlag || minFlag) &&
                                    "0.6rem 1.2rem"
                                  }`,
                                  wordWrap: `${
                                    maxFlag || minFlag ? "normal" : ""
                                  }`,
                                }}
                                className={
                                  i === 0
                                    ? "d-flex align-items-center word-wrap"
                                    : "word-wrap"
                                }
                              >
                                {col?.title === "Ticket FLR" ||
                                col?.title === "Ticket TAT" ? (
                                  <>
                                    <span>
                                      {/*ticket attrbiute based on time */}
                                      {SecondstoHumanReadable(value)}
                                    </span>
                                  </>
                                ) : col?.title === "Ticket ID" ? (
                                  <>
                                    <span
                                      className="cursor-pointer"
                                      onClick={() => {
                                        onExternal(
                                          value,
                                          obj?.["BrandID"] || obj?.["Brand ID"]
                                        );
                                      }}
                                      style={{
                                        marginLeft: "0.5rem",
                                        color: "blue",
                                      }}
                                    >
                                      {value}
                                    </span>
                                  </>
                                ) : col?.title === "First Level Response" ? (
                                  <>
                                    <span
                                      style={{
                                        color:
                                          obj?.[
                                            "FLR Breached"
                                          ]?.toLowerCase() === "yes"
                                            ? "#FF5D48"
                                            : obj?.[
                                                "FLR Breached"
                                              ]?.toLowerCase() === "no"
                                            ? "#1C9F00"
                                            : "",
                                      }}
                                    >
                                      {value?.toLocaleString()}
                                    </span>
                                  </>
                                ) : col?.title ===
                                  "Ticket Category & Sentiment" ? (
                                  <>
                                    {Array.isArray(value) &&
                                      value?.map((data, i) => {
                                        let comma =
                                          i !== value.length - 1 ? " | " : "";
                                        return (
                                          <>
                                            <span
                                              style={{
                                                color:
                                                  obj?.["Ticket Sentiment"]?.[
                                                    i
                                                  ] === "Positive"
                                                    ? "#1C9F00"
                                                    : obj?.[
                                                        "Ticket Sentiment"
                                                      ]?.[i] === "Negative"
                                                    ? "#FF5D48"
                                                    : obj?.[
                                                        "Ticket Sentiment"
                                                      ]?.[i] === "Neutral"
                                                    ? "#DEAA0C"
                                                    : "",
                                              }}
                                            >
                                              {data?.toLocaleString() + comma}
                                            </span>
                                          </>
                                        );
                                      })}
                                  </>
                                ) : col?.title ===
                                  "Mention Category & Sentiment" ? (
                                  <>
                                    {Array.isArray(value) &&
                                      value?.map((data, i) => {
                                        let comma =
                                          i !== value.length - 1 ? " | " : "";
                                        return (
                                          <>
                                            <span
                                              style={{
                                                color:
                                                  obj?.["Mention Sentiment"]?.[
                                                    i
                                                  ] === "Positive"
                                                    ? "#1C9F00"
                                                    : obj?.[
                                                        "Mention Sentiment"
                                                      ]?.[i] === "Negative"
                                                    ? "#FF5D48"
                                                    : obj?.[
                                                        "Mention Sentiment"
                                                      ]?.[i] === "Neutral"
                                                    ? "#DEAA0C"
                                                    : "",
                                              }}
                                            >
                                              {data?.toLocaleString() + comma}
                                            </span>
                                          </>
                                        );
                                      })}
                                  </>
                                ) : col?.title === "Upper Category" ? (
                                  <>
                                    <span
                                      style={{
                                        color: Array.isArray(
                                          obj?.["Upper Category Sentiment"]
                                        )
                                          ? obj?.[
                                              "Upper Category Sentiment"
                                            ]?.[0] === "Positive"
                                            ? "#1C9F00"
                                            : obj?.[
                                                "Upper Category Sentiment"
                                              ]?.[0] === "Negative"
                                            ? "#FF5D48"
                                            : obj?.[
                                                "Upper Category Sentiment"
                                              ]?.[0] === "Neutral"
                                            ? "#DEAA0C"
                                            : ""
                                          : "",
                                      }}
                                    >
                                      {value?.toLocaleString()}
                                    </span>
                                  </>
                                ) : col?.title === "Category & Sentiment" ? (
                                  <>
                                    {Array.isArray(value) &&
                                      value?.map((data, i) => {
                                        let comma =
                                          i !== value.length - 1 ? " | " : "";
                                        return (
                                          <>
                                            <span
                                              style={{
                                                color:
                                                  obj?.["Sentiment"]?.[i] ===
                                                  "Positive"
                                                    ? "#1C9F00"
                                                    : obj?.["Sentiment"]?.[
                                                        i
                                                      ] === "Negative"
                                                    ? "#FF5D48"
                                                    : obj?.["Sentiment"]?.[
                                                        i
                                                      ] === "Neutral"
                                                    ? "#DEAA0C"
                                                    : "",
                                              }}
                                            >
                                              {data?.toLocaleString() + comma}
                                            </span>
                                          </>
                                        );
                                      })}
                                  </>
                                ) : col?.title === "Channel | Inner Channel" ||
                                  col?.title === "Channel Name" ? (
                                  <>
                                    <span
                                      style={{
                                        alignItems: "center",
                                        justifyContent: "center",
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "0.2rem",
                                      }}
                                    >
                                      <img
                                        src={
                                          SocialMedialogo[channlImage]
                                            ? SocialMedialogo[channlImage]
                                            : defaultBrandLogo
                                        }
                                        alt="Channel Image"
                                        style={{
                                          width: "1.8rem",
                                          marginRight: "0.2rem",
                                        }}
                                      />
                                      {channlName}
                                    </span>
                                  </>
                                ) : col?.title === "Assigned To" ? (
                                  <>
                                    <span>
                                      {value?.toLocaleString() === "-" ? (
                                        ""
                                      ) : (
                                        <img
                                          src={
                                            obj?.["Agent Pic"] === "NA" ||
                                            !obj?.["Agent Pic"]
                                              ? defaultProfileImg
                                              : obj?.["Agent Pic"]
                                          }
                                          alt="Agent Profile Image"
                                          style={{
                                            width: "1.8rem",
                                            margin: "0.2rem",
                                          }}
                                        />
                                      )}
                                      {value?.toLocaleString()}
                                    </span>
                                  </>
                                ) : col?.title === "Author" &&
                                  obj[`IsVerified`] === "Verified" ? (
                                  <div>
                                    <img
                                      src={verified}
                                      alt="verified"
                                      className="verified profileImg ml-1"
                                      style={{ height: "1.6rem" }}
                                    />
                                    {value?.toLocaleString()}{" "}
                                  </div>
                                ) : (
                                  value?.toLocaleString()
                                )}
                              </span>
                            </Tooltip>
                          );
                          return updatedObj;
                        }}
                        showSorterTooltip={null} //soting tooltip
                        sortDirections={["ascend", "descend"]}
                        sorter={PdfDownloadStatus ? null : col?.sorter}
                      />
                    );
                  }
                })}
              </Table>
            </div>
          </div>
        )}

        {/* Deep Link Pop Up */}
        {deepLinkModal?.modalShow && (
          <Modal
            title={null}
            visible={deepLinkModal?.modalShow}
            style={{ width: "100%", top: "1rem", paddingBottom: "1rem" }}
            onOk={handleDeepLinkOk}
            onCancel={handleDeepLinkCancel}
            width="100%"
            footer={null}
            className={`deepLinkModal ${
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }`}
          >
            {!deepLinkModal?.url ? (
              <div
                className="loader mx-auto"
                style={{ height: "calc(100vh - 2.6rem)" }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            ) : (
              deepLinkModal?.url
            )}
          </Modal>
        )}
      </div>
    </>
  ) : (
    <NoGraphData errorCode="No data found" />
  );
};

export default React.memo(SmartGrid, isEqual);
